import styled from "styled-components";

const InsightDescriptionStyled = styled.div`
padding: 2rem 10rem 2rem 10rem;
margin: 3rem;
text-align: center;

p {
    color: #070707;
    font-size: 1.59rem;
    margin-top: 0;
}
`

export default InsightDescriptionStyled;
